import PhoneVerificationCodeForm from "../components/PhoneVerificationCodeForm";

export default function PhoneVerificationCode() {
  return (
    <div className="relative z-10 w-full max-w-md px-6 py-40">
      <PhoneVerificationCodeForm />
    </div>
  );
}
